import React from 'react'
import T from 'prop-types'
import ReactDOM from 'react-dom'

export default class Tooltip extends React.Component {
  static displayName = 'Tooltip'

  static propTypes = {
    id: T.string,
    children: T.any,
    className: T.string,
    preferredAlign: T.oneOf([
      'top-right',
      'top-left',
      'bottom-right',
      'bottom-left'
    ]).isRequired,
    rect: T.object.isRequired
  }

  componentDidMount() {
    // let rect = this.props.rect
    this.setPosition(this.props.rect)
  }

  setPosition = rect => {
    const el = ReactDOM.findDOMNode(this)
    const { offsetWidth, offsetHeight } = el

    let [alignY, alignX] = this.props.preferredAlign.split('-')
    if (rect.right + offsetWidth > window.innerWidth) {
      alignX = 'left'
    }
    if (rect.top - offsetHeight < 0) {
      alignY = 'bottom'
    }

    // Update nodes directly; not very React-y but avoids async flashes
    el.style.transform = el.style.WebkitTransform = `translate(${Math.round(
      rect.left + rect.width / 2
    )}px, ${Math.round(rect[alignY])}px)`
    // ReactDOM.findDOMNode(this._contentRef).className += ` ${ alignY }_${ alignX }`
    ReactDOM.findDOMNode(this._contentRef).className = this._getClass(
      `${alignY}_${alignX}`
    )
  }

  _getClass = (additional = '') => {
    return (
      `pw_tooltip pw_tooltip_simple ${this.props.className || ''} ` + additional
    )
  }

  _bindContentRef = c => {
    this._contentRef = c
  }

  render() {
    return (
      <div className="pw_tooltip_wrap" role="tooltip" id={this.props.id}>
        <div className={this._getClass()} ref={this._bindContentRef}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
